// Font Awesome
// import then needed Font Awesome functionality
import {library, dom} from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import {faInstagram, faFacebookF} from '@fortawesome/free-brands-svg-icons';

import {faTag, faArrowRight, faCircle, faAngleUp as fasFaAngleUp, faFilter} from '@fortawesome/free-solid-svg-icons';

import {faAngleUp as farFaAngleUp} from '@fortawesome/pro-regular-svg-icons';

import {faAngleUp as falFaAngleUp} from '@fortawesome/pro-light-svg-icons';

// add the imported icons to the library
library.add(faFacebookF, faInstagram, faTag, faArrowRight, faCircle, fasFaAngleUp, farFaAngleUp, falFaAngleUp, faFilter);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();



// WEBPACK FOOTER //
// ./scripts/autoload/_fontawesome.js